
import type { PasswordRequirement } from '../types/password-requirements-types';
export const passwordRequirements: PasswordRequirement[] = [
  {
    label: 'At least 8 characters',
    test: (password: string) => password.length >= 8,
  },
  {
    label: 'At least 1 uppercase letter',
    test: (password: string) => /[A-Z]/.test(password),
  },
  {
    label: 'At least 1 lowercase letter',
    test: (password: string) => /[a-z]/.test(password),
  },
];
